import { Form, Input, Select, Typography } from "antd";

const { Title } = Typography;
const ContactUs = () => {
  return (
    <div className="my-8">
      <Title level={3}>Contact Us</Title>
      <div className="text-left my-8 px-16 max-sm:px-4 sm:w-1/2 shadow-lg mx-auto py-8">
        <Form layout="vertical">
          <Form.Item label="Name" name="name">
            <Input placeholder="Name" />
          </Form.Item>
          <Form.Item label="Select a reason" name="reason">
            <Select
              showSearch
              placeholder="Select a reason"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={[
                { value: "1", label: "Return & Refund" },
                { value: "2", label: "Employment at ALP" },
                { value: "3", label: "Partnership" },
                { value: "3", label: "Media Queries" },
                { value: "3", label: "Change address for Whole Saler" },
              ]}
            />
          </Form.Item>
          <Form.Item label="Email" name="email">
            <Input type="email" placeholder="Email" />
          </Form.Item>
          <Form.Item label="Mobile Number" name="mblNumber">
            <Input placeholder="Mobile Number" />
          </Form.Item>
          <Form.Item label="Message" name="message">
            <Input.TextArea placeholder="Message" />
          </Form.Item>
          <Form.Item>
            <button className="bg-[#B91C1C] text-white px-4 py-2 rounded-lg">
              Submit
            </button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default ContactUs;
